/**
 * Injiziert die Typografie-Grundwerte (Shop-Einstellungen → Typografie) als
 * CSS mit Null-Spezifität (`:where`), damit einzelne Block-Einstellungen im
 * Seiten-Editor weiterhin gewinnen.
 *
 * - Ohne `override`: lädt die globalen Werte aus /api/shop/settings.
 * - Mit `override`: rendert nur das per-Seiten/Beitrag-Textbild.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { typographyCss } from '@/lib/shopTypography';

const API = process.env.REACT_APP_BACKEND_URL;

let _cached = null;
let _promise = null;

function loadTypography() {
  if (_cached) return Promise.resolve(_cached);
  if (_promise) return _promise;
  _promise = axios.get(`${API}/api/shop/settings`)
    .then((r) => { _cached = (r.data && r.data.typography) || {}; return _cached; })
    .catch(() => { _cached = {}; return _cached; });
  return _promise;
}

export default function ShopTypographyStyle({ override = null, scope = '.hs-root' }) {
  const [typo, setTypo] = useState(override || _cached);

  useEffect(() => {
    if (override) { setTypo(override); return; }
    let alive = true;
    loadTypography().then((t) => { if (alive) setTypo(t); });
    return () => { alive = false; };
  }, [override]);

  if (!typo) return null;
  return (
    <style data-shop-typography={scope} dangerouslySetInnerHTML={{ __html: typographyCss(typo, scope) }} />
  );
}
